import { render, staticRenderFns } from "./UpgradePage.vue?vue&type=template&id=85922720&scoped=true"
import script from "./UpgradePage.vue?vue&type=script&lang=js"
export * from "./UpgradePage.vue?vue&type=script&lang=js"
import style0 from "./UpgradePage.vue?vue&type=style&index=0&id=85922720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85922720",
  null
  
)

export default component.exports